import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

// Admin authentication is handled by an HttpOnly cookie (set by the backend
// on /api/admin/login and cleared by /api/admin/logout). The cookie cannot
// be read or written by JavaScript, which is exactly what we want — it
// defeats XSS-driven token theft.
//
// `withCredentials: true` tells axios to include same-origin cookies on every
// request. CORS on the backend uses a strict origin allow-list, so the
// browser only sends the cookie to klymart.com (or the preview origin).
export const api = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' },
  timeout: 20000,
  withCredentials: true,
});
